import { PkceClient } from '@flybits/iamflybits';
import { useCallback, useMemo } from 'react';

export default function useAuth(projectID: string, params: Record<string, string> = {}) {
  const paramString = useMemo(() => new URLSearchParams(params).toString(), [params]);
  const client = useMemo(
    () =>
      projectID
        ? new PkceClient({
            env: {
              rpHost: process.env.REACT_APP_API_URL as string,
            },
            clientID: `experiences.${process.env.REACT_API_ENV}.flybits.com`,
            projectID,
            appCallbackURL: `${window.location.origin}/auth-callback/${projectID}${
              paramString ? `?${paramString}` : ''
            }`,
            useBroker: import.meta.env.DEV,
          })
        : null,
    [projectID, paramString],
  );

  const requestAuth = useCallback(
    () => (client ? client.request() : Promise.reject(new Error('Project ID is required'))),
    [client],
  );
  const getAuthToken = useCallback(async () => {
    if (!client) {
      return Promise.reject(new Error('Project ID is required'));
    }
    const response = await client.requestRPAuthz();
    return response.accessToken;
  }, [client]);

  return {
    requestAuth,
    getAuthToken,
  };
}
